import type { SVGProps } from 'react';

const SvgTranscription = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6.006 15.015c1.65 0 3-1.35 3-3v-6c0-1.65-1.35-3-3-3s-3 1.35-3 3v6c0 1.65 1.35 3 3 3m-1-9c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1z"
    />
    <path
      fill="currentcolor"
      d="M12.006 11.015c-.55 0-1 .45-1 1 0 2.76-2.24 5-5 5-.57 0-1.13-.1-1.67-.28-.52-.18-1.09.09-1.28.61-.18.52.09 1.09.61 1.28.43.15.88.25 1.33.31v1.08c0 .55.45 1 1 1s1-.45 1-1v-1.08c3.39-.49 6-3.4 6-6.92 0-.55-.45-1-1-1zm0-2h8c.55 0 1-.45 1-1s-.45-1-1-1h-8c-.55 0-1 .45-1 1s.45 1 1 1m8 2h-4c-.55 0-1 .45-1 1s.45 1 1 1h4c.55 0 1-.45 1-1s-.45-1-1-1m-2 4h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1"
    />
  </svg>
);
export default SvgTranscription;
